/*
 * Copyright (c) 2000-2017 Northwest Evaluation Association ~ All rights reserved.
 */

import {
  ProductNames,
  ItemAidsInitOrder,
} from './renderer-constants'

export default class ItemAidsPanelModel {
  constructor (product, itemAidsConfiguration) {
    let productType = (product || '').toLowerCase()

    // We like STATE better so we swap to it internally when we parse items
    if (productType === ProductNames.ACADEMIC_PROFICIENCY_NWEA) {
      productType = ProductNames.STATE
    }
    this.product = productType || ProductNames.MAP

    this.itemAids = Array.from(itemAidsConfiguration)

    this.container = {
      name: 'container-item-aid',
    }
  }

  get itemAidsInInitOrder () {
    return this.itemAids.slice().sort((itemAidOne, itemAidTwo) => {
      return ItemAidsInitOrder.indexOf(itemAidOne.name) - ItemAidsInitOrder.indexOf(itemAidTwo.name)
    })
  }
}
